export default [
    {
      path: '/vouchers',
      name: 'vouchers-read',
      component: () => import('@/views/vouchers/vouchers-list/VouchersList.vue'),
      meta: {
        resource: 'Vouchers',
        action: 'read',
      },
    },
    {
      path: '/vouchers/create',
      name: 'vouchers-create',
      component: () => import('@/views/vouchers/vouchers-form/VouchersForm.vue'),
      meta: {
        resource: 'Vouchers',
        action: 'create',
      },
  },
  ]
  